import React, { Component } from 'react'
import { T } from 'lioness'

/**
 * End View
 */
class EndView extends Component {
  render() {
    return (
      <div className="EndView">
        <h1>
          <T>Thank you!</T>
        </h1>
      </div>
    )
  }
}

export default EndView



// WEBPACK FOOTER //
// ./src/containers/EndView.js